<template>
  <bvue-ui-view class="flex flex-col">
    <div class="flex items-center">
      <h1>Reservas</h1>
      <div class="flex-1 flex justify-end">
        <button @click="add" class="btn btn-primary">Añadir</button>
      </div>
    </div>
    <p>Pulsa en la fila para editar</p>
    <div class="flex-1 overflow-scroll relative">
      <sortable-table :items="items" :columns="columns" startSort="id" @rowSelected="rowSelected"/>
    </div>
  </bvue-ui-view>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import firebase from '@/firebase'
import SortableTable from '@/components/SortableTable'
import NewReserve from '@/pages/admin/NewReserve'
export default {
  name: 'Reserves',
  data() {
    return {
      columns: [
        {
          key: 'name',
          name: 'nombre',
          align: 'left',
          sortable: true,
          type: 'text'
        },
        {
          key: 'price',
          name: 'precio',
          align: 'center',
          sortable: true,
          type: 'text'
        },
        {
          key: 'ecosystemName',
          name: 'ecosistema',
          align: 'left',
          sortable: true,
          type: 'text'
        },
        {
          key: 'active',
          name: 'activa',
          align: 'center',
          sortable: true,
          type: 'boolean'
        },
      ]
    }
  },
  components: {
    SortableTable
  },
  computed: {
    items() {
      var response = []
      const itemsObj = this.$store.state.reserves.items
      if (itemsObj) {
        for (const key in itemsObj) {
          const item = itemsObj[key]
          const ecosystem = this.$store.state.ecosystems.items[item.ecosystem]
          response.push({
            ...item,
            ecosystemName: ecosystem ? ecosystem.name : '',
          })
        }
      }
      return response
    }
  },
  methods: {
    add() {
      this.$bvueUi.modal.show({
        component: NewReserve,
        width: 800,
        height: 800,
        data: {}
      })
    },
    rowSelected(args) {
      if (args.length > 1) {
        const item = args[1]
        this.$router.push('/admin/reserves/'+item.id)
      }
    }
  },
  created() {
    
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/Reserves.vue